// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__32E6j","Open":"SideDrawer_Open__BiXdL","Close":"SideDrawer_Close__3EX-e","Logo":"SideDrawer_Logo__2Wdyl"};